<section class="internal-notes">
  <button
    class="internal-notes__header"
    type="button"
    [attr.aria-expanded]="!isCollapsed()"
    (click)="isCollapsed.set(!isCollapsed())"
  >
    <span>{{ title() }}</span>
    <svg
      class="internal-notes__chevron"
      [class.is-collapsed]="isCollapsed()"
      viewBox="0 0 12 8"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M1 1.5 6 6.5 11 1.5" />
    </svg>
  </button>

  <div [ngbCollapse]="isCollapsed()">
    <div class="internal-notes__body">
      @if (allowAdd()) {
        <form
          class="internal-notes__composer"
          (submit)="$event.preventDefault(); submitNote()"
        >
          <textarea
            class="internal-notes__input"
            [formControl]="noteControl"
            [maxlength]="characterLimit()"
            [placeholder]="placeholder()"
            aria-label="Internal note"
            rows="3"
          ></textarea>
          <div class="internal-notes__composer-footer">
            <span
              class="internal-notes__counter"
              [attr.aria-label]="
                remainingCharacters() + ' characters remaining'
              "
            >
              {{ remainingCharacters() }}
            </span>
            <button
              class="internal-notes__add"
              type="submit"
              [disabled]="!canSubmit()"
            >
              {{ isSaving() ? "Adding…" : "Add note" }}
            </button>
          </div>
        </form>
        @if (saveError(); as error) {
          <p class="internal-notes__error" role="alert">{{ error }}</p>
        }
      }

      <div class="internal-notes__status" role="status" aria-live="polite">
        @if (isLoading()) {
          <p>Loading notes…</p>
        }
      </div>

      @if (!isLoading()) {
        @if (loadError(); as error) {
          <div class="internal-notes__load-error">
            <p class="internal-notes__error" role="alert">{{ error }}</p>
            <button
              class="internal-notes__retry"
              type="button"
              [disabled]="isSaving()"
              (click)="retryLoad.emit()"
            >
              Try again
            </button>
          </div>
        } @else {
          <div
            class="internal-notes__list"
            [class.internal-notes__list--expanded]="isNotesExpanded()"
          >
            @for (note of visibleNotes(); track note.id) {
              <article
                class="internal-notes__note"
                [class.internal-notes__note--preview]="
                  !isNotesExpanded() && $index === notesPerPage()
                "
                [attr.aria-hidden]="
                  !isNotesExpanded() && $index === notesPerPage()
                    ? 'true'
                    : null
                "
              >
                <p class="internal-notes__metadata">
                  <time [attr.datetime]="note.createdDate">
                    {{ note.createdDate | date: dateFormat() : timezone() }}
                  </time>
                  @if (note.noteUser) {
                    <span>
                      note by {{ note.noteUser }}
                      @if (note.noteUserTitle) {
                        , {{ note.noteUserTitle }}
                      }
                    </span>
                  }
                </p>
                <div class="internal-notes__note-content">
                  <svg
                    class="internal-notes__note-icon"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    focusable="false"
                  >
                    <rect x="3" y="2" width="18" height="20" rx="3" />
                    <path d="M7 7h10M7 11h10M7 15h7M7 19h4" />
                  </svg>
                  <p class="internal-notes__note-text">{{ note.noteBody }}</p>
                </div>
              </article>
            } @empty {
              <p class="internal-notes__empty">No notes yet.</p>
            }
          </div>
          @if (canExpandNotes()) {
            <button
              class="internal-notes__more"
              type="button"
              [attr.aria-label]="
                isNotesExpanded() ? 'Show fewer notes' : 'Show more notes'
              "
              [attr.aria-expanded]="isNotesExpanded()"
              (click)="toggleNotes()"
            >
              <lib-icon
                iconName="internalNotesArrowDownIcon"
                [class.is-expanded]="isNotesExpanded()"
                aria-hidden="true"
              ></lib-icon>
            </button>
          }
        }
      }
    </div>
  </div>
</section>
